<div class="slider-container" (click)="onTrackClick($event)">
    <!-- track -->
    <div class="track"></div>
  
    <!-- ticks + labels -->
    <ng-container *ngFor="let t of ticks; let i = index">
      <!-- <div
        class="tick"
        [style.left.%]="(i / 9) * 100"
      ></div> -->
      <div
        class="label"
        [style.left.%]="(i / 9) * 100"
      >
        {{ t }}
      </div>
    </ng-container>
  
    <!-- handle -->
    <div
      class="handle"
      [style.left.%]="((value - 1) / 9) * 100"
    ></div>
  </div>
  